export const EditIndustryTypeFormData = [
    {
      name: "name",
      label: "Industry Type",
      rules: [
        {
          required: true,
          message: 'Please input industry type',
        },
      ],
    }
  ];